import { SessionModel, SessionService } from '../session';
import { catchError, map, share } from 'rxjs/operators';
import { BasketService } from './basket.service';
import {
  BasketSetExtraBody,
  BasketSetRoomBody,
} from './model/basket.interface';
import { Http } from '../../core/http';
import { BasketApi } from './basket.api';
import { Observable, of, zip } from 'rxjs';
import { BasketModel } from './model';

let fetchGetBasket$: Observable<BasketModel> | null;

const fetchGetBasket = (session: SessionModel) => {
  if (!fetchGetBasket$) {
    const headers = {
      'X-AVP-Properties':
        'Prices|Taxes|RoomInformation|RateInformation|ExtraInformation',
      'X-AVP-PictureTemplates': 'Original|XLarge',
    };
    fetchGetBasket$ = Http.get<any>(BasketApi.get(session.sessionId), {
      headers,
    }).pipe(share());
  }

  return fetchGetBasket$;
};

const updateBasketAndSession = (session: SessionModel) => {
  return zip(
    BasketService.fetchBasket(session),
    SessionService.fetchSession(session.sessionId, { preventShare: true })
  ).pipe(
    map(([basket]) => basket),
    catchError((err) => {
      return of(err as BasketModel);
    })
  );
};

const fetchSetRoomInBasket = (
  sessionId: SessionModel['sessionId'],
  body: BasketSetRoomBody
) => {
  return Http.post<void, BasketSetRoomBody>(BasketApi.setRoom(sessionId), body);
};

const fetchSetExtraInBasket = (
  sessionId: SessionModel['sessionId'],
  body: BasketSetExtraBody
) => {
  return Http.post<void, BasketSetExtraBody>(
    BasketApi.setExtra(sessionId),
    body
  );
};

const resetCacheFetchGetBasket = () => (fetchGetBasket$ = null); //TODO CHECK FIX

export const BasketHelperService = {
  updateBasketAndSession,
  fetchSetRoomInBasket,
  fetchSetExtraInBasket,
  fetchGetBasket,
  resetCacheFetchGetBasket,
};
